// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29OY1","top":"styles_top__cUreN","left":"styles_left__39Wtv","description":"styles_description__2p0WM"};